import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Principal } from "../models/principal";
import { PrincipalService } from "../services/principal.service";
import { ProductService } from "../services/product.service";
import { CartService } from "../services/cart.service";
import { Router } from "@angular/router";
import { ProductSuccessAddComponent } from "../product/product-success-add/product-success-add.component";
import { Promo } from "../models/promo";
import { PromoService } from "../services/promo.service";
import { AdminHeaderComponent } from "../layouts/admin-header/admin-header.component";
import * as firebase from "firebase";
import * as typeformEmbed from "@typeform/embed";
import { Survey } from "../models/survey";
import { SurveyService } from "../services/survey.service";
import { Product } from "src/app/models/product";
import { AlertComponent } from "../alert/alert.component";
import { ArticleService } from "../services/article.service";
import { AuthenticationService } from '../services/authentication.service';

declare var $: any;
let listImageViewed = [];

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit {

  public userProfile = JSON.parse(localStorage.getItem("user-profile"));
  public userId = this.userProfile.customer_code;

  public promos: Promo[] = [];
  public principals: Principal[] = [];
  public products: Product[] = [];
  public surveys: Survey[] = [];
  public articles: any[] = [];

  public isLoadingPromo = true;
  public isLoadingPrincipals = true;
  public isLoadingProducts = true;
  public isLoadArticle = true;
  public limit = 8;
  public off = 0;
  public canShowMoreProduct = false;
  public articleExist = true;

  public isEmptyPromo = false;
  public isEmptyProduct = false;
  public isHideDetailButton = true;

  public activeBannerId: string;
  public contentGT: '';
  public titleGT: '';

  @ViewChild("alertModal") alertModal: AlertComponent;
  @ViewChild("addToCartModal") addToCartModal: ProductSuccessAddComponent;
  @ViewChild(AdminHeaderComponent) header: AdminHeaderComponent;
  @ViewChild("articleContainer", { read: ElementRef })  public articleContainer: ElementRef<any>;

  constructor(
    public articleService: ArticleService,
    public principalService: PrincipalService,
    private cartService: CartService,
    public productService: ProductService,
    private promoService: PromoService,
    private surveyService: SurveyService,
    private authService: AuthenticationService,
    private router: Router
  ) {
    window.scrollTo(0, 0);
  }

  ngOnInit() {
    $('#gtModal').removeClass('d-flex align-items-center');

    this.checkGT();
    this.getSurvey();
    this.checkActiveBanner();

    this.promoService.getPromoHome(
      (data) => {
        this.promos = data;
        this.applyJqueryScript();
        this.isEmptyPromo = false;
        this.isLoadingPromo = false;

        if (data && data.length !== 0) {
          this.activeBannerId = this.promos[0].id;
          this.whatIsActive(data);
          this.isHideDetailButton = false;
        }

        if (data && data.length === 0) {
          this.isEmptyPromo = true;
        }
      },
      (err) => {
        console.log(err);
      }
    );

    this.articleService.getListArticles(
      'row=6',
      (data)=>{
        this.articles = data;
        if(this.articles.length === 0){
          this.articleExist = false;
        }
        this.isLoadArticle = false;
      },
      (err)=>{
        this.alertModal.show("Gagal", err.message);
      }
    );

    this.principalService.getPrincipalHighlighted(
      (data) => {
        this.principals = data;
        this.isLoadingPrincipals = false;
      },
      (err) => {
        console.log(err);
      }
    );

    this.productService.getHomeProducts(
      this.limit,
      this.off,
      (data) => {
        this.products = data;
        this.getPromo(this.products);

        if (data && data.length > 0) {
          this.off += this.limit;
          this.isEmptyProduct = false;
          this.canShowMoreProduct = true;
        } else {
          this.canShowMoreProduct = false;
        }

        if (this.products && this.products.length === 0) {
          this.isEmptyProduct = true;
        }
        this.isLoadingProducts = false;
      },
      (err) => {
        console.log(err);
      }
    );

    $("body").on("keypress", "input[type=number][maxlength]", function (event) {
      var key = event.keyCode || event.charCode;
      var txtVal = $(this).val();
      var maxlength = $(this).attr("maxlength");
      if (key > 31 && (key < 48 || key > 57)) {
        return false;
      }
      if (txtVal.length == maxlength) {
        event.preventDefault();
        return false;
      }
      return true;
    });

    $("body").on("paste", "input[type=number][maxlength]", function (event) {
      return false;
    });

    $('#gtModal').on('hidden.bs.modal', function () {
      $(this).removeClass('d-flex align-items-center');
    });
  }

  checkGT() {
    const isGT = localStorage.getItem('gtStatus');
    const isTOP = localStorage.getItem('topStatus');
    const hasRead = localStorage.getItem('hasReadGT');
    const isLogin = localStorage.getItem('isLogin');

    if (isGT === 'true' && isTOP === 'true' && !hasRead && isLogin === 'false') {
      this.authService.getGTContent((resp) => {
        this.titleGT = resp.data.title;
        this.contentGT = resp.data.content;
      });

      $(".gtModal").addClass('d-flex align-items-center');
      $(".gtModal").modal("toggle");
    }
  }

  hasReadGT() {
    localStorage.setItem('hasReadGT', 'true');
  }

  // CR10
  getPromo(data) {
    this.products = data;
    let productCodes = [];

    if (this.products) {
      this.products.forEach(item => {
        productCodes.push(item.code);
      });

      const paramPromo = {
        customerCode: JSON.parse(localStorage.getItem('user-profile')).customer_code,
        branch: JSON.parse(localStorage.getItem('user-profile')).branch_id,
        productCodes
      };

      this.productService.getProductsPromo(paramPromo, (response) => {
        const filt = response.filter(x => x.promotions);
        for (const item of filt) {
          let found = this.products.find(x => x.code === item.productCode);
          found.discount_list = item.promotions;
          found.label = item.label;
          found.max_show_discount = 2;
        }
        this.isLoadingProducts = false;
      }, (err) => {
        this.isLoadingProducts = false;
      });
    }
  }

  openDetailPromo(id: string) {
    const arrow = document.getElementById(`arrow_detail_${id}`);
    if (arrow) {
      arrow.classList.toggle("rotate");
    }

    const panel = document.getElementById(`panel_${id}`);
    if (panel) {
      const disp = panel.style.display;
      panel.style.display = (disp === 'block') ? 'none' : 'block';
    }

    const showMore = document.getElementById(`show_more_${id}`);
    if (showMore) {
      showMore.style.display = 'block';
    }

    let found = this.products.find(x => x.code === id);
    found.max_show_discount = 2;
  }

  showMoreDiscountList(id: string) {
    const showMore = document.getElementById(`show_more_${id}`);
    if (showMore) {
      showMore.style.display = 'none';
    }

    let found = this.products.find(x => x.code === id);
    found.max_show_discount = 1000;
  }

  public getSurvey(): void {
    this.surveys = this.surveyService.getSurvey(
      (data) => {
        this.surveys = data;
        this.applyJqueryScript();
      },
      (err) => {
        console.log(err);
      }
    );
  }

  checkActiveBanner() {
    $(".carousel").on("slid.bs.carousel", () => {
      this.activeBannerId = $(".active").find("img").attr("id");
    });
  }

  whatIsActive(data) {
    $(".carousel").on("slide.bs.carousel", function (e) {
      const bannerId = $(".active").find("img").attr("id");
      const banner = data.find((x) => x.id === bannerId);
      const bannerTitle = banner.title;

      if (window.event) {
        isInViewport(bannerId, bannerTitle);
        return;
      }

      isInViewport(bannerId, bannerTitle);
    });

    function isInViewport(id: string, title: string) {
      const userProfile = JSON.parse(localStorage.getItem("user-profile"));
      const customerCode = userProfile.customer_code;

      const bounding = document.getElementById(id).getBoundingClientRect();

      if (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth) &&
        bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight)
      ) {
        logEvent(id, title, customerCode);
        // const isExist = listImageViewed.find((x) => x.bannerId === id);
        // if (!isExist) {
        //   const bannerView = {
        //     bannerId: id,
        //     bannerTitle: title,
        //     userId: customerCode,
        //     timeView: new Date(),
        //   };

        //   listImageViewed.push(bannerView);
        //   logEvent(id, title, customerCode);
        // } else if (isExist) {
        //   const index = listImageViewed.findIndex((x) => x.bannerId === id);
        //   const lastView = listImageViewed[index].timeView;
        //   const dateTime = new Date();
        //   const difference = dateTime.getTime() - lastView.getTime();
        //   const resultInMinutes = difference / 60000;

        //   if (resultInMinutes >= 10) {
        //     const bannerView = {
        //       bannerId: id,
        //       bannerTitle: title,
        //       userId: customerCode,
        //       timeView: new Date(),
        //     };

        //     listImageViewed.splice(index, 1);
        //     listImageViewed.push(bannerView);
        //     logEvent(id, title, customerCode);
        //   }
        // }
      }
    }

    function logEvent(bannerId: string, bannerTitle: string, userId: string) {
      firebase.analytics().logEvent("view_banner", {
        banner_id: bannerId,
        banner_title: bannerTitle,
        customer_id: userId,
      });
    }
  }

  changeSource(event) {
    event.target.src = "/assets/img/info/no-image-info.png";
  }

  applyJqueryScript(): void {
    $(document).ready(function () {
      $(".carousel").carousel({
        interval: 1000 * 3,
      });

      $(".surveyModal").modal();
    });
  }

  public addToCart(product: Product): void {
    firebase.analytics().logEvent("home_add_to_cart_sering_dibeli_button");

    if (product.ref_quantity > 0) {
      this.addProductToCart(product);
    } else {
      this.products.find((x) => x.code === product.code).alert_message =
        "Masukkan jumlah pesanan terlebih dahulu";
    }
  }

  private addProductToCart(product: Product, isBuyNow = false) {
    this.cartService.addToCart(
      product.code,
      product.unit_of_measure,
      product.ref_quantity,
      product.product_category,
      (data) => {
        if (isBuyNow) {
          this.router.navigate(["/cart"]);
        } else {
          this.addToCartModal.showWithData(product, true);
        }
        this.header.loadCart();
      },
      (err) => {
        this.addToCartModal.showWithData(product, false, err);
      }
    );
  }

  public navigateBanner(promo: Promo): void {
    const userProfile = JSON.parse(localStorage.getItem("user-profile"));
    const userId = userProfile.customer_code;
    const bannerId = promo.id;
    const bannerTitle = promo.title;

    const isGT = localStorage.getItem("gtStatus");
    const isTOP = localStorage.getItem("topStatus");

    firebase.analytics().logEvent("click_banner", {
      banner_id: bannerId,
      banner_title: bannerTitle,
      customer_id: userId,
    });

    if (promo.internal === 0 && promo.external === "") {
      this.router.navigate(["/detail-promo/" + promo.id]);
    } else if (promo.internal === 0 && promo.external !== "") {
      window.open(promo.external, "_blank");
    } else if (promo.internal !== 0) {
      switch (promo.internal) {
        case 1:
          this.router.navigate(["/product/add"]);
          break;
        case 2:
          this.router.navigate(["/cart"]);
          break;
        case 3:
          this.router.navigate(["/voucher"]);
          break;
        case 4:
          this.router.navigate(["/reward"]);
          break;
        case 5:
          this.router.navigate(["/point"]);
          break;
        case 6:
          if (isGT === "true" && isTOP === "true") {
            this.ngOnInit();
          } else {
            this.router.navigate(["/receivable"]);
          }
          break;
        case 61:
          if (isGT === "true" && isTOP === "true") {
            this.ngOnInit();
          } else {
            this.router.navigate(["/receivable"], {
              queryParams: { status: "overdue" },
            });
          }
          break;
        case 62:
          if (isGT === "true" && isTOP === "true") {
            this.ngOnInit();
          } else {
            this.router.navigate(["/receivable"], {
              queryParams: { status: "not-due" },
            });
          }
          break;
        case 63:
          if (isGT === "true" && isTOP === "true") {
            this.ngOnInit();
          } else {
            this.router.navigate(["/receivable"], {
              queryParams: { status: "due" },
            });
          }
          break;
        case 7:
          if (isGT === "true" && isTOP === "true") {
            this.ngOnInit();
          } else {
            this.router.navigate(["/receivable"], {
              queryParams: { tab: "payment" },
            });
          }
          break;
        case 8:
          const productCode = promo.product_code;
          this.getProductDetail(productCode);
          break;
        case 91:
          this.router.navigate(["/principal"]);
          break;
        case 92:
          const principalId = promo.principal_id;
          this.getPrincipalDetail(principalId);
          break;
        case 11:
          this.router.navigate(["/transaction"]);
          break;
        case 12:
          this.router.navigate(["/help"]);
          break;
        case 13:
          this.router.navigate(["/product"]);
          break;
        case 14:
          this.router.navigate(["/account/change-password"]);
          break;
      }
    }
  }

  public getProductDetail(productCode) {
    this.productService.getProductDetail(
      productCode,
      (data) => {
        const product: Product = data;
        product.composition_description = "";
        product.usability_description = "";
        product.how_to_use_description = "";
        this.navigateToProductDetail(product);
      },
      (err) => {
        this.alertModal.show("Gagal", err.message);
      }
    );
  }

  public getPrincipalDetail(principalId) {
    this.productService.getPrincipalDetail(
      principalId,
      (data) => {
        const principal: Principal = data;
        this.goToProduct(principal);
      },
      (err) => {
        this.alertModal.show("Gagal", err.message);
      }
    );
  }

  public navigateToPromoDetail(): void {
    this.router.navigate(["/detail-promo/" + this.activeBannerId]);
  }

  public navigateToProductDetail(product: Product): void {
    this.router.navigate([`/detail-product/${btoa(JSON.stringify(product))}`]);
  }

  public goToArticle(artikel: any){
    firebase.analytics().logEvent('click_home_article');

    this.router.navigate(['/detail-artikel/', artikel.id])
  }

  public goToArticleList(){
    this.router.navigate(['/artikel/'], {queryParams: {page: 1, row: 12}});

  }

  public goToProduct(data: Principal) {
    this.router.navigate([`/product/principal/${btoa(JSON.stringify(data))}`]);
  }

  showMoreProduct() {
    firebase.analytics().logEvent("home_produk_sering_dibeli_button");

    this.isLoadingProducts = true;
    this.canShowMoreProduct = false;

    this.productService.getHomeProducts(
      this.limit,
      this.off,
      (data) => {
        if (data.length > 0) {
          data.forEach((item) => {
            this.products.push(item);
          });

          this.getPromo(this.products);

          this.canShowMoreProduct = true;
        }

        this.off += this.limit;
        this.isLoadingProducts = false;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  public showSurvey(link: string): void {
    $(".surveyModal").modal("hide");

    //const that = this;
    const utc = this.surveyService.getUtc();
    const linkSurvey = link + utc;

    const reference = typeformEmbed.makePopup(linkSurvey, {
      mode: "popup",
      // onSubmit() {
      //   reference.close();
      //   that.getSurvey();
      // }
    });

    reference.open();
  }

  public dismissSurvey(id: string): void {
    this.surveyService.dismissSurvey(
      id,
      (data) => { },
      (err) => {
        console.log(err);
      }
    );
  }

  // article horizontal scroll

  articleToLeft(){
    this.articleContainer.nativeElement.scrollTo({left: (this.articleContainer.nativeElement.scrollLeft - 150), behaviour: 'smooth'});
  }

  articleToRight(){
    this.articleContainer.nativeElement.scrollTo({left: (this.articleContainer.nativeElement.scrollLeft + 150), behaviour: 'smooth'});
  }


}
